// camel-case JS variable versions of CSS variables used by Ant Design
const light = {
  color: {
    colorAccentDefault: "#f8d904",
    colorAccentBgDefault: "#f8d904",
    colorAccentBorderDefault: "#f8d904",
    colorAccentIconDefault: "#f8d904",
    colorAccentTextDefault: "#f8d904",

    // BRAND
    colorBrandBgDefault: "#2259FF",
    colorBrandBgHover: "#4a7dff",
    colorBrandBgPressed: "#113dd9",
    colorBrandBgSoftDefault: "#edf5ff",
    colorBrandBgSoftHover: "#c4dbff",
    colorBrandBgSoftPressed: "#c4dbff", // TODO: get rid of?
    colorBrandBorderDefault: "#9cbeff",
    colorBrandTextDefault: "#2259ff",
    colorBrandIconDefault: "#00719f",
    colorBrandIconHover: "#005d89",
    colorBrandIconPressed: "#005d89",

    // TEXT
    colorTextPrimaryDefault: "#000000",
    colorTextSecondaryDefault: "#4C4C4C",
    colorTextTertiaryDefault: "#6d6d6d",
    colorTextQuaternaryDefault: "#909090",
    colorTextInverseDefault: "#ffffff",
    colorTextLinkDefault: "#2259ff",
    colorTextLinkHover: "#4a7dff",
    colorTextLinkPressed: "#113dd9",
    colorTextLinkSoft: "#edf5ff",
    colorTextLinkSoftHover: "#c4dbff",
    colorTextLinkSoftPressed: "#c4dbff",

    // SURFACES
    colorSurfaceBaseBg: "#f4f4f4",
    colorSurfaceMainBg: "#ffffff",
    colorSurfaceRaisedBg: "#ffffff",
    colorSurfaceBoldBg: "#001e33",
    colorSurfaceSunkenBg: "#eeeeee",
    colorSurfaceBackdropBg: "#ffffffe5",
    colorSurfaceOverlayBg: "#000000b2",
    // background borders
    colorSurfaceBackdropBorder: "#d5d5d5",
    colorSurfaceMainBorder: "#d5d5d5",
    colorSurfaceRaisedBorder: "#b1b1b1",

    colorCriticalDefault: "#d31510",
    colorCriticalBgDefault: "#d31510",
    colorCriticalBgHover: "#b40000",
    colorCriticalBgPressed: "#930000",
    colorCriticalBgSoftDefault: "#ffebe7",
    colorCriticalBgSoftHover: "#ffddd6",
    colorCriticalBgSoftPressed: "#ffcdc3",
    colorCriticalBorderDefault: "#d31510",
    colorCriticalIconDefault: "#d31510",
    colorCriticalIconHover: "#b40000",
    colorCriticalIconPressed: "#930000",
    colorCriticalTextDefault: "#d31510",
    colorDisabledBgDefault: "#0000000d",
    colorDisabledBorderDefault: "#00000012",
    colorDisabledIconDefault: "#909090",
    colorDisabledTextDefault: "#909090",
    colorDiscoveryDefault: "#5d13b7",
    colorDiscoveryBgDefault: "#5d13b7",
    colorDiscoveryBgHover: "#470c94",
    colorDiscoveryBgPressed: "#33106a",
    colorDiscoveryBorderDefault: "#5d13b7",
    colorDiscoveryTextDefault: "#5d13b7",
    colorFormBgDefault: "#f8f8f8",
    colorFormBgSection: "#ffffff",
    colorFormIconDefault: "#222222",
    colorFormIconHover: "#222222",
    colorFormIconPressed: "#222222",
    colorFormInputBgDefault: "#ffffff",
    colorFormInputBorderDefault: "#00000066",
    colorFormLabelSelectors: "#222222",
    colorFormSelectorDefault: "#ffffff",
    colorFormSelectorFocus: "#ffffff",
    colorFormSelectorHover: "#ffffff",
    colorFormSelectorPressed: "#ffffff",
    colorIconButtonBgBold: "#00719f",
    colorIconButtonBgBoldHover: "#0086b4",
    colorIconButtonBgBoldPressed: "#019cc8",
    colorIconButtonBgDefault: "#ffffff8c",
    colorIconButtonBgHover: "#d3faff",
    colorIconButtonBgPressed: "#c5f8ff",
    colorIconButtonFillBold: "#ffffff",
    colorIconButtonFillBoldHover: "#ffffff",
    colorIconButtonFillBoldPressed: "#ffffff",
    colorIconButtonFillDefault: "#222222",
    colorIconButtonFillHover: "#00719f",
    colorIconButtonFillPressed: "#005d89",
    colorInfoDefault: "#0265dc",
    colorInfoBgDefault: "#0265dc",
    colorInfoBgHover: "#0054b6",
    colorInfoBgPressed: "#004491",
    colorInfoBgSoftDefault: "#e0f2ff",
    colorInfoBgSoftHover: "#cae8ff",
    colorInfoBgSoftPressed: "#b5deff",
    colorInfoBorderDefault: "#0265dc",
    colorInfoIconDefault: "#0265dc",
    colorInfoIconHover: "#0054b6",
    colorInfoIconPressed: "#004491",
    colorInfoTextDefault: "#0265dc",
    colorNavBgDefault: "#001e33",
    colorNavItemBgDefault: "#001e33",
    colorNavItemBgHover: "#ffffff40",
    colorNavItemBgPressed: "#ffffff4d",
    colorNavItemBorderDefault: "#17b4dd",
    colorNavItemIconDefault: "#ffffff",
    colorNavItemIconHover: "#17b4dd",
    colorNavItemIconPressed: "#17b4dd",
    colorNavItemTextDefault: "#ffffff",
    colorNavItemTextHover: "#17b4dd",
    colorNavItemTextPressed: "#17b4dd",
    colorSchemeBlueBgDefault: "#eff9ff",
    colorSchemeBlueBgHover: "#e8f5ff",
    colorSchemeBlueBgPressed: "#e0f2ff",
    colorSchemeBlueBorderDefault: "#59a7f6",
    colorSchemeBlueTextDefault: "#0054b6",
    colorSchemeBrownBgDefault: "#fff5e5",
    colorSchemeBrownBgHover: "#fff1d9",
    colorSchemeBrownBgPressed: "#ffeccc",
    colorSchemeBrownBorderDefault: "#cb5d00",
    colorSchemeBrownTextDefault: "#7a2f00",
    colorSchemeCharcoalBgDefault: "#ffffff00",
    colorSchemeCharcoalBgHover: "#f8f8f8",
    colorSchemeCharcoalBgPressed: "#eeeeee",
    colorSchemeCharcoalBorderDefault: "#6d6d6d",
    colorSchemeCharcoalTextDefault: "#464646",
    colorSchemeCyanBgDefault: "#f1fdff",
    colorSchemeCyanBgHover: "#e2fbff",
    colorSchemeCyanBgPressed: "#d3faff",
    colorSchemeCyanBorderDefault: "#12b0da",
    colorSchemeCyanTextDefault: "#00719f",
    colorSchemeFuchsiaBgDefault: "#fff4fd",
    colorSchemeFuchsiaBgHover: "#ffeffd",
    colorSchemeFuchsiaBgPressed: "#ffe9fc",
    colorSchemeFuchsiaBorderDefault: "#ed74ed",
    colorSchemeFuchsiaTextDefault: "#9d039e",
    colorSchemeGrayBgDefault: "#eeeeee",
    colorSchemeGrayBgHover: "#e6e6e6",
    colorSchemeGrayBgPressed: "#d5d5d5",
    colorSchemeGrayBorderDefault: "#909090",
    colorSchemeGrayTextDefault: "#464646",
    colorSchemeGreenBgDefault: "#f3feef",
    colorSchemeGreenBgHover: "#e6fddf",
    colorSchemeGreenBgPressed: "#d9fdcf",
    colorSchemeGreenBorderDefault: "#07a721",
    colorSchemeGreenTextDefault: "#007c0f",
    colorSchemeIndigoBgDefault: "#f6f7ff",
    colorSchemeIndigoBgHover: "#f1f2ff",
    colorSchemeIndigoBgPressed: "#edeeff",
    colorSchemeIndigoBorderDefault: "#9599ff",
    colorSchemeIndigoTextDefault: "#5258e4",
    colorSchemeLimeBgDefault: "#f6fedb",
    colorSchemeLimeBgHover: "#edfdb6",
    colorSchemeLimeBgPressed: "#e4fd92",
    colorSchemeLimeBorderDefault: "#87b103",
    colorSchemeLimeTextDefault: "#577400",
    colorSchemeMagentaBgDefault: "#fff5f8",
    colorSchemeMagentaBgHover: "#ffeff5",
    colorSchemeMagentaBgPressed: "#ffeaf1",
    colorSchemeMagentaBorderDefault: "#ef5a98",
    colorSchemeMagentaTextDefault: "#c82269",
    colorSchemeMintBgDefault: "#f3fdf7",
    colorSchemeMintBgHover: "#e7fbef",
    colorSchemeMintBgPressed: "#dafae8",
    colorSchemeMintBorderDefault: "#2fb880",
    colorSchemeMintTextDefault: "#007a4d",
    colorSchemeOrangeBgDefault: "#fffaf2",
    colorSchemeOrangeBgHover: "#fff5e5",
    colorSchemeOrangeBgPressed: "#fff1d9",
    colorSchemeOrangeBorderDefault: "#f68511",
    colorSchemeOrangeTextDefault: "#b14c00",
    colorSchemePurpleBgDefault: "#fbf5ff",
    colorSchemePurpleBgHover: "#f8f0ff",
    colorSchemePurpleBgPressed: "#f6ebff",
    colorSchemePurpleBorderDefault: "#bd8bfc",
    colorSchemePurpleTextDefault: "#893de7",
    colorSchemeRedBgDefault: "#fff5f3",
    colorSchemeRedBgHover: "#fff0ed",
    colorSchemeRedBgPressed: "#ffebe7",
    colorSchemeRedBorderDefault: "#f75c46",
    colorSchemeRedTextDefault: "#d31510",
    colorSchemeSeafoamBgDefault: "#f3fdfc",
    colorSchemeSeafoamBgHover: "#e7fbf9",
    colorSchemeSeafoamBgPressed: "#daf9f6",
    colorSchemeSeafoamBorderDefault: "#0fb5ae",
    colorSchemeSeafoamTextDefault: "#007772",
    colorSchemeYellowBgDefault: "#fefbe5",
    colorSchemeYellowBgHover: "#fdf8cb",
    colorSchemeYellowBgPressed: "#fcf5b2",
    colorSchemeYellowBorderDefault: "#e8c600",
    colorSchemeYellowTextDefault: "#705300",
    colorSuccessDefault: "#18752C",
    colorSuccessBgDefault: "#18752C",
    colorSuccessBgHover: "#00653e",
    colorSuccessBgPressed: "#005132",
    colorSuccessBgSoftDefault: "#cef8e0",
    colorSuccessBgSoftHover: "#adf4ce",
    colorSuccessBgSoftPressed: "#89ecbc",
    colorSuccessBorderDefault: "#18752C",
    colorSuccessIconDefault: "#18752C",
    colorSuccessIconHover: "#00653e",
    colorSuccessIconPressed: "#005132",
    colorSuccessTextDefault: "#18752C",
    colorWarningDefault: "#e46f00",
    colorWarningBgDefault: "#e46f00",
    colorWarningBgHover: "#cb5d00",
    colorWarningBgPressed: "#b14c00",
    colorWarningBgSoftDefault: "#ffeccc",
    colorWarningBgSoftHover: "#ffdfad",
    colorWarningBgSoftPressed: "#fdd291",
    colorWarningBorderDefault: "#e46f00",
    colorWarningIconDefault: "#e46f00",
    colorWarningIconHover: "#cb5d00",
    colorWarningIconPressed: "#b14c00",
    colorWarningTextDefault: "#e46f00",
  },
}
const dark = {
  color: {
    colorAccentDefault: "#f7d804",
    colorAccentBgDefault: "#f7d804",
    colorAccentBorderDefault: "#f7d804",
    colorAccentIconDefault: "#f7d804",
    colorAccentTextDefault: "#f7d804",
    colorBrandDefault: "#17b4dd",
    colorBrandHover: "#04a0cd",
    colorBrandPressed: "#008cba",
    colorBrandBgDefault: "#17b4dd",
    colorBrandBgHover: "#04a0cd",
    colorBrandBgPressed: "#008cba",
    colorBrandBgSoftDefault: "#000000",
    colorBrandBgSoftHover: "#001522",
    colorBrandBgSoftPressed: "#002944",
    colorBrandBorderDefault: "#17b4dd",
    colorBrandIconDefault: "#17b4dd",
    colorBrandIconHover: "#39c7ea",
    colorBrandIconPressed: "#39c7ea",
    colorBrandTextDefault: "#17b4dd",
    colorBrandTextHover: "#39c7ea",
    colorBrandTextPressed: "#39c7ea",
    colorCriticalDefault: "#ff816b",
    colorCriticalBgDefault: "#ff816b",
    colorCriticalBgHover: "#ff9e8c",
    colorCriticalBgPressed: "#ffb7a9",
    colorCriticalBgSoftDefault: "#570000",
    colorCriticalBgSoftHover: "#6e0000",
    colorCriticalBgSoftPressed: "#8a0000",
    colorCriticalBorderDefault: "#ff816b",
    colorCriticalIconDefault: "#ff816b",
    colorCriticalIconHover: "#ff9e8c",
    colorCriticalIconPressed: "#ffb7a9",
    colorCriticalTextDefault: "#ff816b",
    colorDisabledBgDefault: "#ffffff1a",
    colorDisabledBorderDefault: "#ffffff1a",
    colorDisabledIconDefault: "#6a6a6a",
    colorDisabledTextDefault: "#6a6a6a",
    colorDiscoveryDefault: "#dbbcfe",
    colorDiscoveryBgDefault: "#dbbcfe",
    colorDiscoveryBgHover: "#e6cfff",
    colorDiscoveryBgPressed: "#f0e0ff",
    colorDiscoveryBorderDefault: "#dbbcfe",
    colorDiscoveryTextDefault: "#dbbcfe",
    colorFormBgDefault: "#1d1d1d",
    colorFormBgSection: "#ffffff",
    colorFormIconDefault: "#ebebeb",
    colorFormIconHover: "#ebebeb",
    colorFormIconPressed: "#ebebeb",
    colorFormInputBgDefault: "#ffffff",
    colorFormInputBorderDefault: "#ffffff80",
    colorFormLabelSelectors: "#ffffff",
    colorFormSelectorDefault: "#ffffff",
    colorFormSelectorFocus: "#ffffff",
    colorFormSelectorHover: "#ffffff",
    colorFormSelectorPressed: "#ffffff",
    colorIconButtonBgBold: "#17b4dd",
    colorIconButtonBgBoldHover: "#04a0cd",
    colorIconButtonBgBoldPressed: "#008cba",
    colorIconButtonBgDefault: "#0000008c",
    colorIconButtonBgHover: "#001f33",
    colorIconButtonBgPressed: "#002944",
    colorIconButtonFillBold: "#000000",
    colorIconButtonFillBoldHover: "#000000",
    colorIconButtonFillBoldPressed: "#000000",
    colorIconButtonFillDefault: "#ebebeb",
    colorIconButtonFillHover: "#17b4dd",
    colorIconButtonFillPressed: "#39c7ea",
    colorInfoDefault: "#5eaaf7",
    colorInfoBgDefault: "#5eaaf7",
    colorInfoBgHover: "#7cbdfa",
    colorInfoBgPressed: "#98cefd",
    colorInfoBgSoftDefault: "#002651",
    colorInfoBgSoftHover: "#00326a",
    colorInfoBgSoftPressed: "#004087",
    colorInfoBorderDefault: "#5eaaf7",
    colorInfoIconDefault: "#5eaaf7",
    colorInfoIconHover: "#7cbdfa",
    colorInfoIconPressed: "#98cefd",
    colorInfoTextDefault: "#5eaaf7",
    colorNavBgDefault: "#cef9ff",
    colorNavItemBgDefault: "#cef9ff",
    colorNavItemBgHover: "#00000040",
    colorNavItemBgPressed: "#0000004d",
    colorNavItemBorderDefault: "#006793",
    colorNavItemIconDefault: "#0e0e0e",
    colorNavItemIconHover: "#006793",
    colorNavItemIconPressed: "#006793",
    colorNavItemTextDefault: "#0e0e0e",
    colorNavItemTextHover: "#006793",
    colorNavItemTextPressed: "#006793",
    colorSchemeBlueBgDefault: "#001329",
    colorSchemeBlueBgHover: "#001d3d",
    colorSchemeBlueBgPressed: "#002651",
    colorSchemeBlueBorderDefault: "#066ce7",
    colorSchemeBlueTextDefault: "#5eaaf7",
    colorSchemeBrownBgDefault: "#280d01",
    colorSchemeBrownBgHover: "#351201",
    colorSchemeBrownBgPressed: "#481801",
    colorSchemeBrownBorderDefault: "#d26200",
    colorSchemeBrownTextDefault: "#e87400",
    colorSchemeCharcoalBgDefault: "#1d1d1d",
    colorSchemeCharcoalBgHover: "#272727",
    colorSchemeCharcoalBgPressed: "#303030",
    colorSchemeCharcoalBorderDefault: "#b0b0b0",
    colorSchemeCharcoalTextDefault: "#b0b0b0",
    colorSchemeCyanBgDefault: "#001522",
    colorSchemeCyanBgHover: "#001f33",
    colorSchemeCyanBgPressed: "#002944",
    colorSchemeCyanBorderDefault: "#0079a7",
    colorSchemeCyanTextDefault: "#17b4dd",
    colorSchemeFuchsiaBgDefault: "#230722",
    colorSchemeFuchsiaBgHover: "#350b33",
    colorSchemeFuchsiaBgPressed: "#460e44",
    colorSchemeFuchsiaBorderDefault: "#d341d5",
    colorSchemeFuchsiaTextDefault: "#ef78ee",
    colorSchemeGrayBgDefault: "#1d1d1d",
    colorSchemeGrayBgHover: "#272727",
    colorSchemeGrayBgPressed: "#303030",
    colorSchemeGrayBorderDefault: "#8d8d8d",
    colorSchemeGrayTextDefault: "#b0b0b0",
    colorSchemeGreenBgDefault: "#001804",
    colorSchemeGreenBgHover: "#001f05",
    colorSchemeGreenBgPressed: "#002f07",
    colorSchemeGreenBorderDefault: "#009714",
    colorSchemeGreenTextDefault: "#2dbf3a",
    colorSchemeIndigoBgDefault: "#0d0f31",
    colorSchemeIndigoBgHover: "#141649",
    colorSchemeIndigoBgPressed: "#1a1d61",
    colorSchemeIndigoBorderDefault: "#5a60eb",
    colorSchemeIndigoTextDefault: "#999dff",
    colorSchemeLimeBgDefault: "#101600",
    colorSchemeLimeBgHover: "#151c00",
    colorSchemeLimeBgPressed: "#202b00",
    colorSchemeLimeBorderDefault: "#5d7b00",
    colorSchemeLimeTextDefault: "#7aa100",
    colorSchemeMagentaBgDefault: "#2a0215",
    colorSchemeMagentaBgHover: "#3e021f",
    colorSchemeMagentaBgPressed: "#530329",
    colorSchemeMagentaBorderDefault: "#e34589",
    colorSchemeMagentaTextDefault: "#f1619c",
    colorSchemeMintBgDefault: "#05160e",
    colorSchemeMintBgHover: "#071d12",
    colorSchemeMintBgPressed: "#0a2c1c",
    colorSchemeMintBorderDefault: "#008252",
    colorSchemeMintTextDefault: "#34bb84",
    colorSchemeOrangeBgDefault: "#280d01",
    colorSchemeOrangeBgHover: "#351201",
    colorSchemeOrangeBgPressed: "#481801",
    colorSchemeOrangeBorderDefault: "#ba5200",
    colorSchemeOrangeTextDefault: "#f98917",
    colorSchemePurpleBgDefault: "#190834",
    colorSchemePurpleBgHover: "#260c4e",
    colorSchemePurpleBgPressed: "#321068",
    colorSchemePurpleBorderDefault: "#9146ec",
    colorSchemePurpleTextDefault: "#c08ffc",
    colorSchemeRedBgDefault: "#300000",
    colorSchemeRedBgHover: "#410000",
    colorSchemeRedBgPressed: "#570000",
    colorSchemeRedBorderDefault: "#ee4331",
    colorSchemeRedTextDefault: "#f9634c",
    colorSchemeSeafoamBgDefault: "#091615",
    colorSchemeSeafoamBgHover: "#0c1c1b",
    colorSchemeSeafoamBgPressed: "#122b2a",
    colorSchemeSeafoamBorderDefault: "#007f79",
    colorSchemeSeafoamTextDefault: "#1ab9b2",
    colorSchemeYellowBgDefault: "#1d1400",
    colorSchemeYellowBgHover: "#281b00",
    colorSchemeYellowBgPressed: "#352400",
    colorSchemeYellowBorderDefault: "#674d00",
    colorSchemeYellowTextDefault: "#c7a200",
    colorSuccessDefault: "#34bb84",
    colorSuccessBgDefault: "#34bb84",
    colorSuccessBgHover: "#4bcd95",
    colorSuccessBgPressed: "#67dea8",
    colorSuccessBgSoftDefault: "#0a2c1c",
    colorSuccessBgSoftHover: "#073b24",
    colorSuccessBgSoftPressed: "#004c2e",
    colorSuccessBorderDefault: "#34bb84",
    colorSuccessIconDefault: "#34bb84",
    colorSuccessIconHover: "#4bcd95",
    colorSuccessIconPressed: "#67dea8",
    colorSuccessTextDefault: "#34bb84",
    colorSurfaceBackdropBg: "#ffffffb2",
    colorSurfaceBackdropBorder: "#4b4b4b",
    colorSurfaceBaseBg: "#1d1d1d",
    colorSurfaceBoldBg: "#303030",
    colorSurfaceMainBg: "#000000",
    colorSurfaceMainBorder: "#4b4b4b",
    colorSurfaceOverlayBg: "#ffffffb2",
    colorSurfaceRaisedBg: "#000000",
    colorSurfaceRaisedBorder: "#6a6a6a",
    colorSurfaceSunkenBg: "#272727",
    colorTextInverseDefault: "#000000",
    colorTextLinkDefault: "#17b4dd",
    colorTextLinkHover: "#39c7ea",
    colorTextLinkPressed: "#60d8f3",
    colorTextLinkSoft: "#00456c",
    colorTextLinkSoftHover: "#005680",
    colorTextLinkSoftPressed: "#006793",
    colorTextPrimaryDefault: "#ffffff",
    colorTextQuaternaryDefault: "#8d8d8d",
    colorTextSecondaryDefault: "#ebebeb",
    colorTextTertiaryDefault: "#b0b0b0",
    colorWarningDefault: "#d26200",
    colorWarningBgDefault: "#d26200",
    colorWarningBgHover: "#e87400",
    colorWarningBgPressed: "#f98917",
    colorWarningBgSoftDefault: "#481801",
    colorWarningBgSoftHover: "#5c2000",
    colorWarningBgSoftPressed: "#732b00",
    colorWarningBorderDefault: "#d26200",
    colorWarningIconDefault: "#d26200",
    colorWarningIconHover: "#e87400",
    colorWarningIconPressed: "#f98917",
    colorWarningTextDefault: "#d26200",
  },
}

const lightColors = light.color
const darkColors = dark.color

// primitive colors exported from Figma as JS variables used by Ant Desig
const primitiveColors = {
  darkBlue100: "#002651",
  darkBlue1000: "#7cbdfa",
  darkBlue1100: "#98cefd",
  darkBlue1200: "#b3defe",
  darkBlue1300: "#ceeaff",
  darkBlue1400: "#e3f3ff",
  darkBlue200: "#00326a",
  darkBlue25: "#000f20",
  darkBlue300: "#004087",
  darkBlue400: "#004ea6",
  darkBlue50: "#001329",
  darkBlue500: "#005cc8",
  darkBlue600: "#066ce7",
  darkBlue700: "#1d80f5",
  darkBlue75: "#001d3d",
  darkBlue800: "#4096f3",
  darkBlue900: "#5eaaf7",
  darkCyan100: "#002944",
  darkCyan1000: "#39c7ea",
  darkCyan1100: "#60d8f3",
  darkCyan1200: "#86e6fa",
  darkCyan1300: "#aaf2ff",
  darkCyan1400: "#cef9ff",
  darkCyan200: "#003658",
  darkCyan25: "#00101b",
  darkCyan300: "#00456c",
  darkCyan400: "#005680",
  darkCyan50: "#001522",
  darkCyan500: "#006793",
  darkCyan600: "#0079a7",
  darkCyan700: "#008cba",
  darkCyan75: "#001f33",
  darkCyan800: "#04a0cd",
  darkCyan900: "#17b4dd",
  darkFuchsia100: "#460e44",
  darkFuchsia1000: "#f695f3",
  darkFuchsia1100: "#fbaff6",
  darkFuchsia1200: "#fec7f8",
  darkFuchsia1300: "#ffdcfa",
  darkFuchsia1400: "#ffebfc",
  darkFuchsia200: "#5d095c",
  darkFuchsia25: "#1c061b",
  darkFuchsia300: "#780078",
  darkFuchsia400: "#920093",
  darkFuchsia50: "#230722",
  darkFuchsia500: "#a913aa",
  darkFuchsia600: "#bf2bbf",
  darkFuchsia700: "#d341d5",
  darkFuchsia75: "#350b33",
  darkFuchsia800: "#e45be5",
  darkFuchsia900: "#ef78ee",
  darkGreen100: "#002f07",
  darkGreen1000: "#50d052",
  darkGreen1100: "#73e06b",
  darkGreen1200: "#93ed83",
  darkGreen1300: "#b4f7a2",
  darkGreen1400: "#d5fcca",
  darkGreen200: "#003d09",
  darkGreen25: "#001303",
  darkGreen300: "#004d0c",
  darkGreen400: "#005f0f",
  darkGreen50: "#001804",
  darkGreen500: "#00710f",
  darkGreen600: "#00840f",
  darkGreen700: "#009714",
  darkGreen75: "#001f05",
  darkGreen800: "#0dab25",
  darkGreen900: "#2dbf3a",
  darkIndigo100: "#1a1d61",
  darkIndigo1000: "#aeb1ff",
  darkIndigo1100: "#c2c4ff",
  darkIndigo1200: "#d4d5ff",
  darkIndigo1300: "#e3e4ff",
  darkIndigo1400: "#f0f0ff",
  darkIndigo200: "#23277d",
  darkIndigo25: "#0a0c27",
  darkIndigo300: "#2e329e",
  darkIndigo400: "#3a3fbd",
  darkIndigo50: "#0d0f31",
  darkIndigo500: "#494ed8",
  darkIndigo600: "#5a60eb",
  darkIndigo700: "#6e73f6",
  darkIndigo75: "#141649",
  darkIndigo800: "#8488fd",
  darkIndigo900: "#999dff",
  darkLime100: "#202b00",
  darkLime1000: "#9ac60b",
  darkLime1100: "#aad816",
  darkLime1200: "#bbe829",
  darkLime1300: "#cdf648",
  darkLime1400: "#e1fd84",
  darkLime200: "#2a3800",
  darkLime25: "#0d1100",
  darkLime300: "#364800",
  darkLime400: "#425800",
  darkLime50: "#101600",
  darkLime500: "#4f6900",
  darkLime600: "#5d7b00",
  darkLime700: "#6b8e00",
  darkLime75: "#151c00",
  darkLime800: "#7aa100",
  darkLime900: "#8ab403",
  darkMagenta100: "#530329",
  darkMagenta1000: "#ff98bf",
  darkMagenta1100: "#ffb3cf",
  darkMagenta1200: "#ffcadd",
  darkMagenta1300: "#ffdde9",
  darkMagenta1400: "#ffecf3",
  darkMagenta200: "#6a0034",
  darkMagenta25: "#210110",
  darkMagenta300: "#850041",
  darkMagenta400: "#a1004e",
  darkMagenta50: "#2a0215",
  darkMagenta500: "#ba165d",
  darkMagenta600: "#d12b72",
  darkMagenta700: "#e34589",
  darkMagenta75: "#3e021f",
  darkMagenta800: "#f1619c",
  darkMagenta900: "#fc7cad",
  darkMint100: "#0a2c1c",
  darkMint1000: "#4bcd95",
  darkMint1100: "#67dea8",
  darkMint1200: "#89ecbc",
  darkMint1300: "#b1f4d1",
  darkMint1400: "#d6f9e4",
  darkMint200: "#073b24",
  darkMint25: "#04120b",
  darkMint300: "#004c2e",
  darkMint400: "#005d39",
  darkMint50: "#05160e",
  darkMint500: "#006f45",
  darkMint600: "#008252",
  darkMint700: "#009562",
  darkMint75: "#071d12",
  darkMint800: "#1ca872",
  darkMint900: "#34bb84",
  darkNeutral100: "#1d1d1d",
  darkNeutral150: "#272727",
  darkNeutral200: "#303030",
  darkNeutral300: "#4b4b4b",
  darkNeutral400: "#6a6a6a",
  darkNeutral50: "#000000",
  darkNeutral500: "#8d8d8d",
  darkNeutral600: "#b0b0b0",
  darkNeutral700: "#d0d0d0",
  darkNeutral75: "#0e0e0e",
  darkNeutral800: "#ebebeb",
  darkNeutral900: "#ffffff",
  darkOrange100: "#481801",
  darkOrange1000: "#ffa23b",
  darkOrange1100: "#ffbc66",
  darkOrange1200: "#fdd291",
  darkOrange1300: "#ffe2b5",
  darkOrange1400: "#ffefd5",
  darkOrange200: "#5c2000",
  darkOrange25: "#1d0a00",
  darkOrange300: "#732b00",
  darkOrange400: "#8a3700",
  darkOrange50: "#280d01",
  darkOrange500: "#a24400",
  darkOrange600: "#ba5200",
  darkOrange700: "#d26200",
  darkOrange75: "#351201",
  darkOrange800: "#e87400",
  darkOrange900: "#f98917",
  darkPurple100: "#321068",
  darkPurple1000: "#cea6fd",
  darkPurple1100: "#dbbcfe",
  darkPurple1200: "#e6cfff",
  darkPurple1300: "#f0e0ff",
  darkPurple1400: "#f8edff",
  darkPurple200: "#430d8c",
  darkPurple25: "#14062a",
  darkPurple300: "#5610ad",
  darkPurple400: "#6a1dc8",
  darkPurple50: "#190834",
  darkPurple500: "#7e31de",
  darkPurple600: "#9146ec",
  darkPurple700: "#a25ef6",
  darkPurple75: "#260c4e",
  darkPurple800: "#b277fa",
  darkPurple900: "#c08ffc",
  darkRed100: "#570000",
  darkRed1000: "#ff9e8c",
  darkRed1100: "#ffb7a9",
  darkRed1200: "#ffcdc3",
  darkRed1300: "#ffdfd9",
  darkRed1400: "#ffedea",
  darkRed200: "#6e0000",
  darkRed25: "#230000",
  darkRed300: "#8a0000",
  darkRed400: "#a70000",
  darkRed50: "#300000",
  darkRed500: "#c40706",
  darkRed600: "#dd2118",
  darkRed700: "#ee4331",
  darkRed75: "#410000",
  darkRed800: "#f9634c",
  darkRed900: "#ff816b",
  darkSeafoam100: "#122b2a",
  darkSeafoam1000: "#42cac3",
  darkSeafoam1100: "#66dad3",
  darkSeafoam1200: "#8be8e1",
  darkSeafoam1300: "#b3f2ed",
  darkSeafoam1400: "#d7f8f4",
  darkSeafoam200: "#133937",
  darkSeafoam25: "#071111",
  darkSeafoam300: "#104946",
  darkSeafoam400: "#035b58",
  darkSeafoam50: "#091615",
  darkSeafoam500: "#006c68",
  darkSeafoam600: "#007f79",
  darkSeafoam700: "#00928c",
  darkSeafoam75: "#0c1c1b",
  darkSeafoam800: "#00a59f",
  darkSeafoam900: "#1ab9b2",
  darkYellow100: "#352400",
  darkYellow1000: "#d8b500",
  darkYellow1100: "#e9c700",
  darkYellow1200: "#f7d804",
  darkYellow1300: "#f9e961",
  darkYellow1400: "#fcf3aa",
  darkYellow200: "#442f00",
  darkYellow25: "#150e00",
  darkYellow300: "#563e00",
  darkYellow400: "#674d00",
  darkYellow50: "#1d1400",
  darkYellow500: "#7a5c00",
  darkYellow600: "#8d6c00",
  darkYellow700: "#a17e00",
  darkYellow75: "#281b00",
  darkYellow800: "#b49000",
  darkYellow900: "#c7a200",
  lightBlue100: "#e0f2ff",
  lightBlue1000: "#0054b6",
  lightBlue1100: "#004491",
  lightBlue1200: "#003571",
  lightBlue1300: "#002754",
  lightBlue1400: "#001c3c",
  lightBlue200: "#cae8ff",
  lightBlue25: "#f7fcff",
  lightBlue300: "#b5deff",
  lightBlue400: "#96cefd",
  lightBlue50: "#eff9ff",
  lightBlue500: "#78bbfa",
  lightBlue600: "#59a7f6",
  lightBlue700: "#3892f3",
  lightBlue75: "#e8f5ff",
  lightBlue800: "#147af3",
  lightBlue900: "#0265dc",
  lightCyan100: "#c5f8ff",
  lightCyan1000: "#005d89",
  lightCyan1100: "#004a73",
  lightCyan1200: "#00395d",
  lightCyan1300: "#002a46",
  lightCyan1400: "#001e33",
  lightCyan200: "#a4f0ff",
  lightCyan25: "#f1fdff",
  lightCyan300: "#88e7fa",
  lightCyan400: "#60d8f3",
  lightCyan50: "#e2fbff",
  lightCyan500: "#33c5e8",
  lightCyan600: "#12b0da",
  lightCyan700: "#019cc8",
  lightCyan75: "#d3faff",
  lightCyan800: "#0086b4",
  lightCyan900: "#00719f",
  lightFuchsia100: "#ffe9fc",
  lightFuchsia1000: "#9d039e",
  lightFuchsia1100: "#800081",
  lightFuchsia1200: "#640664",
  lightFuchsia1300: "#470e46",
  lightFuchsia1400: "#320d31",
  lightFuchsia200: "#ffdafa",
  lightFuchsia25: "#fff9fe",
  lightFuchsia300: "#fec7f8",
  lightFuchsia400: "#fbaef6",
  lightFuchsia50: "#fff4fd",
  lightFuchsia500: "#f592f3",
  lightFuchsia600: "#ed74ed",
  lightFuchsia700: "#e055e2",
  lightFuchsia75: "#ffeffd",
  lightFuchsia800: "#cd3ace",
  lightFuchsia900: "#b622b7",
  lightGreen100: "#cdfcbf",
  lightGreen1000: "#00670f",
  lightGreen1100: "#00530d",
  lightGreen1200: "#00400a",
  lightGreen1300: "#003007",
  lightGreen1400: "#002205",
  lightGreen200: "#aef69d",
  lightGreen25: "#f3feef",
  lightGreen300: "#96ee85",
  lightGreen400: "#72e06a",
  lightGreen50: "#e6fddf",
  lightGreen500: "#4ecf50",
  lightGreen600: "#27bb36",
  lightGreen700: "#07a721",
  lightGreen75: "#d9fdcf",
  lightGreen800: "#009112",
  lightGreen900: "#007c0f",
  lightIndigo100: "#edeeff",
  lightIndigo1000: "#4046ca",
  lightIndigo1100: "#3236a8",
  lightIndigo1200: "#262986",
  lightIndigo1300: "#1b1e64",
  lightIndigo1400: "#141648",
  lightIndigo200: "#e0e2ff",
  lightIndigo25: "#fbfbff",
  lightIndigo300: "#d3d5ff",
  lightIndigo400: "#c1c4ff",
  lightIndigo50: "#f6f7ff",
  lightIndigo500: "#acafff",
  lightIndigo600: "#9599ff",
  lightIndigo700: "#7e84fc",
  lightIndigo75: "#f1f2ff",
  lightIndigo800: "#686df4",
  lightIndigo900: "#5258e4",
  lightLime100: "#dbfc6e",
  lightLime1000: "#486000",
  lightLime1100: "#3a4d00",
  lightLime1200: "#2c3b00",
  lightLime1300: "#212c00",
  lightLime1400: "#181f00",
  lightLime200: "#cbf443",
  lightLime25: "#f6fedb",
  lightLime300: "#bce92a",
  lightLime400: "#aad816",
  lightLime50: "#edfdb6",
  lightLime500: "#98c50a",
  lightLime600: "#87b103",
  lightLime700: "#769c00",
  lightLime75: "#e4fd92",
  lightLime800: "#678800",
  lightLime900: "#577400",
  lightMagenta100: "#ffeaf1",
  lightMagenta1000: "#ad0955",
  lightMagenta1100: "#8e0045",
  lightMagenta1200: "#700037",
  lightMagenta1300: "#54032a",
  lightMagenta1400: "#3c061d",
  lightMagenta200: "#ffdce8",
  lightMagenta25: "#fffafb",
  lightMagenta300: "#ffcadd",
  lightMagenta400: "#ffb2ce",
  lightMagenta50: "#fff5f8",
  lightMagenta500: "#ff95bd",
  lightMagenta600: "#fa77aa",
  lightMagenta700: "#ef5a98",
  lightMagenta75: "#ffeff5",
  lightMagenta800: "#de3d82",
  lightMagenta900: "#c82269",
  lightMint100: "#cef8e0",
  lightMint1000: "#00653e",
  lightMint1100: "#005132",
  lightMint1200: "#053f27",
  lightMint1300: "#0a2e1d",
  lightMint1400: "#0a2015",
  lightMint200: "#adf4ce",
  lightMint25: "#f3fdf7",
  lightMint300: "#89ecbc",
  lightMint400: "#67dea8",
  lightMint50: "#e7fbef",
  lightMint500: "#49cc93",
  lightMint600: "#2fb880",
  lightMint700: "#15a46e",
  lightMint75: "#dafae8",
  lightMint800: "#008f5d",
  lightMint900: "#007a4d",
  lightNeutral100: "#f8f8f8",
  lightNeutral150: "#eeeeee",
  lightNeutral200: "#e6e6e6",
  lightNeutral300: "#d5d5d5",
  lightNeutral400: "#b1b1b1",
  lightNeutral50: "#ffffff",
  lightNeutral500: "#909090",
  lightNeutral600: "#6d6d6d",
  lightNeutral700: "#464646",
  lightNeutral75: "#fdfdfd",
  lightNeutral800: "#222222",
  lightNeutral900: "#000000",
  lightOrange100: "#ffeccc",
  lightOrange1000: "#953d00",
  lightOrange1100: "#7a2f00",
  lightOrange1200: "#612300",
  lightOrange1300: "#491901",
  lightOrange1400: "#351201",
  lightOrange200: "#ffdfad",
  lightOrange25: "#fffaf2",
  lightOrange300: "#fdd291",
  lightOrange400: "#ffbb63",
  lightOrange50: "#fff5e5",
  lightOrange500: "#ffa037",
  lightOrange600: "#f68511",
  lightOrange700: "#e46f00",
  lightOrange75: "#fff1d9",
  lightOrange800: "#cb5d00",
  lightOrange900: "#b14c00",
  lightPurple100: "#f6ebff",
  lightPurple1000: "#7326d3",
  lightPurple1100: "#5d13b7",
  lightPurple1200: "#470c94",
  lightPurple1300: "#33106a",
  lightPurple1400: "#230f49",
  lightPurple200: "#eeddff",
  lightPurple25: "#fdfaff",
  lightPurple300: "#e6d0ff",
  lightPurple400: "#dbbbfe",
  lightPurple50: "#fbf5ff",
  lightPurple500: "#cca4fd",
  lightPurple600: "#bd8bfc",
  lightPurple700: "#ae72f9",
  lightPurple75: "#f8f0ff",
  lightPurple800: "#9d57f4",
  lightPurple900: "#893de7",
  lightRed100: "#ffebe7",
  lightRed1000: "#b40000",
  lightRed1100: "#930000",
  lightRed1200: "#740000",
  lightRed1300: "#590000",
  lightRed1400: "#430000",
  lightRed200: "#ffddd6",
  lightRed25: "#fffaf9",
  lightRed300: "#ffcdc3",
  lightRed400: "#ffb7a9",
  lightRed50: "#fff5f3",
  lightRed500: "#ff9b88",
  lightRed600: "#ff7c65",
  lightRed700: "#f75c46",
  lightRed75: "#fff0ed",
  lightRed800: "#ea3829",
  lightRed900: "#d31510",
  lightSeafoam100: "#cef7f3",
  lightSeafoam1000: "#00635f",
  lightSeafoam1100: "#0c4f4c",
  lightSeafoam1200: "#123c3a",
  lightSeafoam1300: "#122c2b",
  lightSeafoam1400: "#0f1f1e",
  lightSeafoam200: "#aaf1ea",
  lightSeafoam25: "#f3fdfc",
  lightSeafoam300: "#8ce9e2",
  lightSeafoam400: "#65dad2",
  lightSeafoam50: "#e7fbf9",
  lightSeafoam500: "#3fc9c1",
  lightSeafoam600: "#0fb5ae",
  lightSeafoam700: "#00a19a",
  lightSeafoam75: "#daf9f6",
  lightSeafoam800: "#008c87",
  lightSeafoam900: "#007772",
  lightYellow100: "#fbf198",
  lightYellow1000: "#705300",
  lightYellow1100: "#5b4300",
  lightYellow1200: "#483300",
  lightYellow1300: "#362500",
  lightYellow1400: "#281a00",
  lightYellow200: "#f8e750",
  lightYellow25: "#fefbe5",
  lightYellow300: "#f8d904",
  lightYellow400: "#e8c600",
  lightYellow50: "#fdf8cb",
  lightYellow500: "#d7b300",
  lightYellow600: "#c49f00",
  lightYellow700: "#b08c00",
  lightYellow75: "#fcf5b2",
  lightYellow800: "#9b7800",
  lightYellow900: "#856600",
  transparentBlack100: "#0000001a",
  transparentBlack200: "#00000033",
  transparentBlack250: "#00000040",
  transparentBlack300: "#0000004d",
  transparentBlack400: "#00000066",
  transparentBlack50: "#0000000d",
  transparentBlack500: "#00000080",
  transparentBlack550: "#0000008c",
  transparentBlack70: "#00000012",
  transparentBlack700: "#000000b2",
  transparentBlack800: "#000000cc",
  transparentBlack900: "#000000e5",
  transparentBrand100: "#12b0da1a",
  transparentBrand150: "#12b0da29",
  transparentBrand20: "#12b0da05",
  transparentBrand200: "#12b0da33",
  transparentBrand250: "#12b0da40",
  transparentBrand300: "#12b0da4d",
  transparentBrand350: "#12b0da5c",
  transparentBrand400: "#12b0da66",
  transparentBrand50: "#12b0da0d",
  transparentBrand500: "#12b0da80",
  transparentBrand600: "#12b0da99",
  transparentBrand70: "#12b0da14",
  transparentBrand700: "#12b0dab2",
  transparentBrand800: "#12b0dacc",
  transparentBrand900: "#12b0dae5",
  transparentWhite0: "#ffffff00",
  transparentWhite100: "#ffffff1a",
  transparentWhite200: "#ffffff33",
  transparentWhite250: "#ffffff40",
  transparentWhite300: "#ffffff4d",
  transparentWhite400: "#ffffff66",
  transparentWhite50: "#ffffff0d",
  transparentWhite500: "#ffffff80",
  transparentWhite550: "#ffffff8c",
  transparentWhite700: "#ffffffb2",
  transparentWhite800: "#ffffffcc",
  transparentWhite900: "#ffffffe5",
}

export { lightColors, darkColors, primitiveColors }
